import { ContentListResults } from "@/types/Facet";

export function useFetchData() {
  const { $fireBangApiDomain } = useNuxtApp();
  // 記事一覧取得
  const { data: fetchFacetContList } = useFetch(
      `${$fireBangApiDomain}/api/facet/cont`,
    {key:'useFetchFacetContList',
      query: {
        limit: 5
      },
      // TODO jsonデータの変換
      transform: (data: ContentListResults) => {
        const results = data ? data.results : [];
        return results;
      },
    }
  );
  return {
    fetchFacetContList,
  };
}
